<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <CompanyContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import CompanyContent from "~~/codepresso-renewal/content/CompanyContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "회사 소개 | 코드프레소",
  meta: [
    { name: "description", content: "역량이 공정하게 평가되는 세상. 2019년 설립 이후 AI 리터러시의 표준을 만들어 온 코드프레소의 미션과 연혁, 인증과 고객의 목소리를 소개합니다." },
    { name: "title", content: "회사 소개 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "회사 소개 | 코드프레소" },
    { property: "og:description", content: "역량이 공정하게 평가되는 세상. 2019년 설립 이후 AI 리터러시의 표준을 만들어 온 코드프레소의 미션과 연혁, 인증과 고객의 목소리를 소개합니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/company.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
